import { z } from 'zod';

export const MAX_TRIP_POSITIONS_PER_PAGE = 500;

/** `GET /trips/:id/positions`: oldest first, a page at a time. `after` is the previous page's `nextCursor`, opaque to the caller. */
export const tripPositionsQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(MAX_TRIP_POSITIONS_PER_PAGE).default(200),
  after: z.string().min(1).max(200).optional(),
});
export type TripPositionsQuery = z.infer<typeof tripPositionsQuerySchema>;
